import { ClickFeature } from '@audacy-clients/client-services';
import {
  checkPlayingById,
  nowPlaying /* playerTimeState */,
} from '@audacy-clients/core/atoms/player';
import { isDefined } from '@audacy-clients/core/components/StateConnectors/utils';
// import { AudacyColors } from '@audacy-clients/core/styles/colors';
// import { ButtonTheme } from '@audacy-clients/rn-components/src/components/Button';
// import { secondsToMilliseconds } from 'date-fns';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';
import Button from '~/components/Button';
// import { Icons } from '~/components/Icon/constants';
import { useAudioHelpersWeb } from '~/hooks/use-audio-helpers-web';
import ItemCell from './ItemCell';
import styles, { Constants } from './styles';
import useTranscript from './useTranscript';

// const getRoundedMs = (time: number) => Math.floor(time / 1000) * 1000;

// TODO - Transcripts: Still need to work on this component, please ignore commented code

export type TranscriptData = {
  transcript: Array<Transcript>;
};

export type Transcript = {
  duration: number;
  end_time: number;
  speaker: string;
  start_time: number;
  text: string;
};

type TranscriptContentProps = {
  transcript: Array<Transcript> | undefined;
  currentIndex: number;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
  duration: number;
  offsetEqualToZero: boolean;
};

const Transcript: React.FC<TranscriptContentProps> = ({
  transcript,
  currentIndex,
  setCurrentIndex,
  duration,
  offsetEqualToZero,
}) => {
  const audioHelpers = useAudioHelpersWeb();
  const playerItem = useRecoilValue(nowPlaying);
  const { id: contentId } = playerItem ?? {};
  const isPlaying = useRecoilValue(checkPlayingById({ contentId }));
  // TODO - Transcripts - data events
  // const {
  //   // Notice: uncomment it when back-end analytics will be ready [CCS-3436]
  //   //sendTranscriptPlayClickEvent,
  //   getAnalyticPlayContext
  // } = useTranscriptAnalytic();

  const [isAutoScrolling, setIsAutoScrolling] = useState(true);

  const transcriptListRef = useRef<Array<HTMLDivElement>>([]);
  // const activeRef = useRef<HTMLDivElement | null>(null);
  // const beforeCurrentTimestampRef = useRef(false);

  // const resumeButtonOpacity = useSharedValue(0);
  // const rotation = useSharedValue(0);

  const scrollToIndex = useCallback(
    (index: number) => {
      if (!transcriptListRef.current || !index) {
        return;
      }

      transcriptListRef.current[index].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    },
    [transcriptListRef],
  );

  // NOTE - Transcripts: May need this for scroll
  // const scrollToOffset = useCallback(
  //   (offset: number) => {
  //     if (!transcriptListRef.current) {
  //       return;
  //     }
  //     transcriptListRef.current.scrollToOffset({
  //       offset,
  //       animated: false,
  //     });
  //   },
  //   [transcriptListRef],
  // );

  useEffect(() => {
    if (currentIndex < 0 || !isAutoScrolling) {
      return;
    }

    scrollToIndex(currentIndex);
  }, [currentIndex, isAutoScrolling, scrollToIndex]);

  const playContext = useMemo(
    () => ({
      contentId,
      feature: ClickFeature.FULL_PLAYER,
    }),
    [contentId],
  );

  const handleTranscriptPress = useCallback(
    (startTimeInMs: number, index: number) => () => {
      setIsAutoScrolling(true);
      setCurrentIndex(index);
      const offset = startTimeInMs / 1000;
      let progress = isDefined(duration) && isDefined(offset) ? offset / duration : undefined;
      if (progress && progress > 1) {
        progress = 1;
      }
      if (isPlaying) {
        return audioHelpers.seekToProgress(progress ?? 0);
      }
      if (offsetEqualToZero) {
        return audioHelpers.playFromId(
          contentId ?? '',
          { feature: ClickFeature.FULL_PLAYER },
          {
            autoPlay: true,
            startOffset: offset,
          },
        );
      }
      audioHelpers.seekToProgress(progress ?? 0);
      audioHelpers.play(undefined, playContext);
    },
    [duration, audioHelpers, playContext, isPlaying, contentId, offsetEqualToZero, setCurrentIndex],
  );

  const renderItem = useCallback(
    (transcript: Transcript, index: number) => {
      const { start_time, speaker, text } = transcript;
      // const roundedStartTime = getRoundedMs(start_time);
      const isActiveItem = index <= currentIndex && currentIndex >= Constants.noIndexFounded;
      // const isActiveItem = offsetInMilliseconds >= roundedStartTime;

      return (
        <ItemCell
          ref={(el) => {
            if (el) {
              transcriptListRef.current[index] = el;
            }
          }}
          index={index}
          startTime={start_time}
          isActive={isActiveItem}
          speaker={speaker}
          text={text}
          handleTranscriptPress={handleTranscriptPress}
        />
      );
    },
    [handleTranscriptPress, currentIndex],
  );

  return (
    <div css={styles.container}>
      <div>
        {transcript?.map((item, index) => (
          <React.Fragment key={`${item.start_time}-${index}`}>
            {renderItem(item, index)}
          </React.Fragment>
        ))}
        {/* Add resume button */}
      </div>

      {!isAutoScrolling && (
        <div>
          {' '}
          {/* style={styles.resumeButtonContainer}>*/}
          <Button
            // icon={beforeCurrentTimestamp ? Icons.CaretDown : Icons.CaretUp} // Ensure icons are compatible
            // onClick={handleResumeAutoScroll} //
            // iconSize={Sizes.size_12} //
            // iconColor={AudacyColors.audacyDarkNavy} // Ensure your color values are valid
            // theme="Light" // Keep theme logic intact
            // style={styles.resumeButton} // Add CSS styles if needed
            // icon={beforeCurrentTimestamp ? Icons.CaretDown : Icons.CaretUp}
            // iconSize={20}
            // style={[styles.button, styles.ttrButton]}
            // theme={ButtonTheme.Navy}
            label={'Hello'} //TODO fix
          />
        </div>
      )}
    </div>
  );
};

const MemoizedTranscriptContent = React.memo(Transcript);

const TranscriptContent = () => {
  const { transcript, currentIndex, setCurrentIndex, duration, offsetEqualToZero } =
    useTranscript();

  return (
    <MemoizedTranscriptContent
      transcript={transcript}
      currentIndex={currentIndex}
      setCurrentIndex={setCurrentIndex}
      duration={duration}
      offsetEqualToZero={offsetEqualToZero}
    />
  );
};

export default TranscriptContent;
